import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { bootstrapAnalytics } from "@/lib/analyticsLoader";

bootstrapAnalytics();

// createRoot replaces the static page rather than hydrating it. Transfer head
// ownership to React too: keep prerender metadata in raw/no-JS HTML, but remove
// its marked copies before React 19 mounts the route's own metadata.
document.head.querySelectorAll('[data-rh="true"]').forEach((tag) => tag.remove());

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
